module.exports = "<div class=ad-banner></div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/ad-banner/ad-banner.html
 ** module id = 53
 ** module chunks = 0
 **/